import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'


// import { } from '@fortawesome/fontawesome-free-regular/shakable.es'

import {
  faArrowRight,
  faCheck,
  faCheckSquare,
  faTimes,
  faArrowCircleRight,
  faCalendar,
  faCalendarAlt,
  faCheckCircle,
  faChevronUp,
  faChevronLeft,
  faChevronDown,
  faChevronRight,
  faCircle,
  faClipboardList,
  faCog,
  faEnvelope,
  faExclamationCircle,
  faEyeSlash,
  faFileExport,
  faFilter,
  faHome,
  faInfoCircle,
  faLock,
  faMedkit,
  faMoneyBill,
  faPills,
  faPlay,
  faPlus,
  faQuestionCircle,
  faRandom,
  faSignInAlt,
  faSignOutAlt,
  faSquare,
  faThermometerHalf,
  faTimesCircle,
  faTrash,
  faUser,
  faUserCircle,
  faUserClock,
  faUserMd,
  faUserNurse,
  faUserPlus,
  faUserCog,
  faUserShield,
  faXRay
} from '@fortawesome/free-solid-svg-icons'

import {
  faCircle as faCircleReg,
  faComment,
} from '@fortawesome/free-regular-svg-icons'

library.add(
  faArrowRight,
  faCheck,
  faCircleReg,
  faTimes,
  faArrowCircleRight,
  faCalendar,
  faCalendarAlt,
  faCheckCircle,
  faCheckSquare,
  faChevronUp,
  faChevronLeft,
  faChevronDown,
  faChevronRight,
  faCircle,
  faClipboardList,
  faCog,
  faComment,
  faEnvelope,
  faExclamationCircle,
  faEyeSlash,
  faFileExport,
  faFilter,
  faHome,
  faInfoCircle,
  faLock,
  faMedkit,
  faMoneyBill,
  faPills,
  faPlay,
  faPlus,
  faQuestionCircle,
  faRandom,
  faSignInAlt,
  faSignOutAlt,
  faSquare,
  faThermometerHalf,
  faTimesCircle,
  faTrash,
  faUser,
  faUserCircle,
  faUserClock,
  faUserMd,
  faUserNurse,
  faUserPlus,
  faUserCog,
  faUserShield,
  faXRay

)

Vue.component('fa', FontAwesomeIcon)
Vue.component('fa-layers', FontAwesomeLayers)
Vue.component('fa-layers-text', FontAwesomeLayersText)